import { MapPin, Navigation, Car, Train } from "lucide-react";

const ADDRESS_LABEL = "Calle San Roque 4, 28710 El Molar, Madrid";
const PLACE_QUERY = "Vibra+Marketing,+Calle+San+Roque,+El+Molar";
const MAPS_URL = `https://www.google.com/maps/search/?api=1&query=${PLACE_QUERY}`;
const DIRECTIONS_URL = `https://www.google.com/maps/dir/?api=1&destination=${PLACE_QUERY}`;
const EMBED_URL = `https://www.google.com/maps?q=${PLACE_QUERY}&hl=es&z=15&output=embed`;

const LocationSection = () => (
  <section id="ubicacion" className="container px-6 py-12 md:py-20 scroll-mt-24">
    <div className="max-w-5xl mx-auto text-center mb-12">
      <h2 className="font-display text-3xl md:text-4xl uppercase mb-4">
        Dónde <span className="text-gradient">estamos</span>
      </h2>
      <p className="text-base text-muted-foreground">
        Oficina en El Molar (Madrid). También trabajamos en remoto con clientes de toda España.
      </p>
    </div>

    <div className="max-w-6xl mx-auto grid lg:grid-cols-5 gap-6">
      {/* Mapa embebido */}
      <div className="lg:col-span-3 rounded-2xl overflow-hidden border border-border bg-card shadow-sm">
        <iframe
          title="Mapa de Vibra Marketing en El Molar, Madrid"
          src={EMBED_URL}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="w-full h-[360px] md:h-[420px] border-0"
          allowFullScreen
        />
      </div>

      {/* Cómo llegar */}
      <aside className="lg:col-span-2 p-7 rounded-2xl border border-border bg-card flex flex-col gap-5">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center shrink-0">
            <MapPin className="w-5 h-5" />
          </div>
          <div>
            <div className="font-display text-lg uppercase">Nuestra oficina</div>
            <address className="not-italic text-sm text-muted-foreground mt-1 leading-relaxed">
              Vibra Marketing<br />
              {ADDRESS_LABEL}
            </address>
          </div>
        </div>

        <div className="h-px bg-border" />

        <div>
          <div className="font-display text-sm uppercase mb-3 text-foreground/80">Cómo llegar</div>
          <ul className="space-y-3 text-sm text-muted-foreground">
            <li className="flex items-start gap-3">
              <Car className="w-4 h-4 text-primary mt-0.5 shrink-0" />
              <span>
                <strong className="text-foreground">En coche:</strong> salida 50 de la A-1, 5 min hasta el centro de El Molar.
              </span>
            </li>
            <li className="flex items-start gap-3">
              <Train className="w-4 h-4 text-primary mt-0.5 shrink-0" />
              <span>
                <strong className="text-foreground">Transporte público:</strong> autobuses 191, 192 y 193 desde Plaza de Castilla.
              </span>
            </li>
          </ul>
        </div>

        <div className="flex flex-col sm:flex-row gap-2 mt-auto pt-2">
          <a
            href={DIRECTIONS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-primary text-primary-foreground text-sm font-medium hover:opacity-90 transition-opacity"
          >
            <Navigation className="w-4 h-4" />
            Cómo llegar
          </a>
          <a
            href={MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-xl border border-border text-sm font-medium hover:border-primary/40 transition-colors"
          >
            <MapPin className="w-4 h-4" />
            Ver en Google Maps
          </a>
        </div>
      </aside>
    </div>
  </section>
);

export default LocationSection;
